import { parseError } from '../errors/parseError';
import { type HttpClient } from '../HttpClient';
import { camelCase, type CamelCased } from '../utility/camelCase';

export type CreateTempSessionIdResponseRaw = {
    temp_session_id: string;
};

export type CreateTempSessionIdResponse = CamelCased<CreateTempSessionIdResponseRaw>;

export type CreateTempSessionIdPayload = {
    /**
     * Only allow the session ID to be used once.
     *
     * @default true
     */
    singleUse?: boolean;

    /**
     * The number of seconds the session ID should be valid for.
     *
     * @default 3600
     */
    timeToLive?: number;

    data?: unknown;
};

export const createTempSessionId = async (
    client: HttpClient,
    payload?: CreateTempSessionIdPayload
): Promise<CreateTempSessionIdResponse> => {
    const { singleUse = true, timeToLive = 3600, data } = payload ?? {};

    try {
        const response = await client
            .use()
            .post<CreateTempSessionIdResponseRaw>('api/zoom/create_temp_session_id', {
                json: {
                    one_time_use: singleUse,
                    time_to_live: timeToLive,
                    data
                }
            })
            .json();

        return camelCase(response);
    } catch (error) {
        throw await parseError(error);
    }
};
